import { bdrCalendarsApiConnector } from 'apiConnector/bdr-calendar';
import { ofType } from 'redux-observable';
import type { Observable, SchedulerLike } from 'rxjs';
import { of } from 'rxjs';
import { catchError, map, mergeMap, timeoutWith } from 'rxjs/operators';
import {
  bdrSettlementCalendarsBlackoutDatesFailed,
  bdrSettlementCalendarsBlackoutDatesReceived,
  bdrSettlementCalendarsBlackoutDatesTimeouted,
} from 'state/settlementDateCalendars/settlementDateCalendars.action';
import type { EpicWithThunk } from 'state/state.common';

export type BdrSettlementCalendarsBlackoutDates = string[];

export interface FetchSettlementCalendarsBlackoutDatesEpicApi {
  getSettlementCalendarsBlackoutDates(currencyCode: string): Observable<BdrSettlementCalendarsBlackoutDates>;
}

export function fetchSettlementCalendarsBlackoutDatesEpic(
  timeoutInMillis: number = 60000,
  appScheduler?: SchedulerLike,
): EpicWithThunk {
  return (actions$, _state$, { httpClient }) =>
    actions$.pipe(
      ofType('SETTLEMENT_CALENDARS_BLACKOUT_DATES_REQUESTED'),
      mergeMap(({ currencyCode }) => {
        return bdrCalendarsApiConnector(httpClient)
          .getSettlementCalendarsBlackoutDates(currencyCode)
          .pipe(
            map(holidays => bdrSettlementCalendarsBlackoutDatesReceived(currencyCode, holidays)),
            catchError(_ => of(bdrSettlementCalendarsBlackoutDatesFailed())),
            timeoutWith(timeoutInMillis, of(bdrSettlementCalendarsBlackoutDatesTimeouted()), appScheduler),
          );
      }),
    );
}
